module.exports = __webpack_public_path__ + "img/koniec.bddefb2e.png";